import { render, staticRenderFns } from "./h4-block.vue?vue&type=template&id=923f5f64&"
import script from "./h4-block.vue?vue&type=script&lang=js&"
export * from "./h4-block.vue?vue&type=script&lang=js&"
import style0 from "./h4-block.vue?vue&type=style&index=0&id=923f5f64&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports